import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import NavigationConstants from "../../enums/NavigationConstants";
import ApplicationCard from '../common/ApplicationCard';
import { setADLoginInProgress } from "../../utils/authUtils";

const AzureSignIn: React.FC = () => {
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const handleTokenAcquisition = async () => {
      if (accounts?.length > 0) {
        try {
          await instance.acquireTokenSilent({
            scopes: ["openid", "profile", "email"],
            account: accounts[0]
          });

          sessionStorage.setItem("internal_token", JSON.stringify(accounts));
          navigate(NavigationConstants.InternalHome);
        } catch (error) {
          console.error("Token acquisition error:", error);
        }
      }
      setIsLoading(false);
    };

    handleTokenAcquisition();
  }, [instance, accounts, navigate]);

  const handleSignIn = async () => {
    try {
      // Set AD login in progress flag
      setADLoginInProgress(true);
      await instance.loginRedirect(loginRequest);
    } catch (error) {
      console.error("Login error:", error);
      // Clear flag on error
      setADLoginInProgress(false);
    }
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div onClick={handleSignIn} style={{ cursor: 'pointer' }}>
      <ApplicationCard
        title="AD Log In"
        description="Internal Users log in"
        url={null}
      />
    </div>
  );
};

export default AzureSignIn;